import React from 'react';
import '../../css/breadcrumb.less';

/**
 * @param {Array} trail Array of objects containing id, content and onClick
 * @param {String} activeItemId Matching id from a trail object
 * @description Creates a breadcrumb navigation
 */
const Breadcrumb = ({ trail, activeItemId }) => {

    const visibleTrail = trail.reduce(
        ({ filteredItems, foundActive }, item) => {

            const isActiveItem = item.id === activeItemId;

            return {
                foundActive: foundActive || isActiveItem,
                filteredItems: foundActive ? filteredItems : filteredItems.concat(item),
            };

        },
        { filteredItems: [], foundActive: false },
    )
        .filteredItems;


    return (
        <div className="breadcrumb-trail">
            {
                visibleTrail.map(({ id, content, onClick }, index, allItems) => {
                    const isFirst = index === 0;
                    const isLast = index === allItems.length - 1;
                    return (
                        <span key={id} className="breadcrumb-item">
                            {
                                !isFirst ? ' > ' : ''
                            }
                            {
                                isLast
                                    ? <span className="breadcrumb-item-active">{ content }</span>
                                    : <button type="button" className="breadcrumb-item-link link-emulate" onClick={onClick}>{ content }</button>
                            }
                        </span>
                    );
                })
            }
        </div>
    );
};

export default Breadcrumb;
